import { toastr } from 'react-redux-toastr';
import { put, takeLatest, call } from 'redux-saga/effects';

import * as actions from '../actions';
import requext from '../../utils/requext';
import graphFetch from '../../util/graphFetch';
import {
    SAVE_ELEMENT_REQUEST,
    GET_PROVIDED_ELEMENT_REQUEST,
    GET_SAVED_ELEMENT_REQUEST,
    REMOVE_ELEMENT_REQUEST,
    REMOVE_ELEMENT_SUCCESS,
} from '../actionTypes';
import { toastrSuccessOptions } from '../../components/Toastr/Toastr';

function* saveElement({ payload }) {
    const { user, data, type, ...rest } = payload;
    const options = {
        queryName: 'saveElement',
        select: `id title thumbnail type tags`,
        args: {
            user: { type: 'ID', value: user },
            data: { type: 'String!', value: data },
            type: { type: 'ElementEnum!', value: type },
            ...rest,
        },
    };

    try {
        const { data } = yield call(graphFetch, options, true);
        if (data.saveElement) {
            toastr.success('Saved!', toastrSuccessOptions);
        }
    } catch (e) {}
}

function* getProvidedElements({ filter }) {
    const query = {
        query: `query elements($filter: ElementEnum!) {
            elements(filter: $filter) {
                id type title thumbnail tags
            }
        }`,
        variables: { filter },
    };
    try {
        const resp = yield requext(undefined, JSON.stringify(query));
        const { data } = yield resp.json();
        if (data && data.elements) {
            yield put(
                actions.getElementSuccess({
                    filter,
                    isPrivate: false,
                    elements: data.elements,
                })
            );
        }
    } catch (e) {
        console.log('Err', e);
    }
}

function* getSavedElements({ filter }) {
    const query = {
        query: `query savedElements($filter: ElementEnum!) {
            profile {
                elements(filter: $filter) {
                    id type title thumbnail data
                }
            }
        }`,
        variables: { filter },
    };
    try {
        const resp = yield requext(undefined, JSON.stringify(query));
        const { data } = yield resp.json();
        if (data && data.profile) {
            yield put(
                actions.getSavedElementSuccess({
                    filter,
                    isPrivate: true,
                    elements: data.profile.elements,
                })
            );
        }
    } catch (e) {
        console.log('Err', e);
    }
}

function* removeElement({ id }) {
    const mutation = true;
    const options = {
        queryName: 'removeElement',
        args: { id: { type: 'ID!', value: id } },
    };

    const { data } = yield call(graphFetch, options, mutation);
    if (data && data.removeElement) {
        toastr.success('Removed!', toastrSuccessOptions);
        yield put({ type: REMOVE_ELEMENT_SUCCESS, id });
    }
}

export default [
    takeLatest(SAVE_ELEMENT_REQUEST, saveElement),
    takeLatest(REMOVE_ELEMENT_REQUEST, removeElement),
    takeLatest(GET_SAVED_ELEMENT_REQUEST, getSavedElements),
    takeLatest(GET_PROVIDED_ELEMENT_REQUEST, getProvidedElements),
];
